module.exports = __webpack_public_path__ + "img/logo-default.6f320af6.png";